import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import confused from 'src/assets/Buy_Policy_Images/confused.svg'
import Button from '@mui/material/Button'
import { COLORS } from 'src/utils/Themes/colors'
import { getConfusedCustomerDetails } from 'src/services/buyPolicyService'
import { getTokenForQrReport } from 'src/services/individualService'
import LoadingModal from 'src/components/common/LoadingModal'
import { scrollToTop } from 'src/utils/commonMethods'
import phone from 'src/assets/Buy_Policy_Images/Phone.svg'
import { CONTACT, NOTIFICATION_TYPES } from 'src/utils/constants/common'
import {
  validateEmail,
  validateName,
  validatePhoneNumber,
} from 'src/utils/commonMethods/validationUtils'
import ContactSmile from 'src/assets/Buy_Policy_Images/ContactSmile.svg'
import { useDispatch } from 'react-redux'
import { showNotificationMessage } from 'src/actions'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import { FORM_ERRORS, HEALTH, INVALID_MOBILE } from 'src/utils/constants/Health'
import { PHONE } from 'src/utils/constants/Individual'
import { CLIENT_IS } from 'src/utils/constants/AppConstants'

const ContactUs = (props) => {
  const classes = useStyles(props)
  const dispatch = useDispatch()
  const [inputData, setInputData] = useState({
    name: '',
    phone: '',
    email: '',
  })
  const [loading, setLoading] = useState(false)
  const [token, setToken] = useState(null)
  const [error, setError] = useState('')

  const validateIndianPhoneNumber = (phoneNumber) => {
    const indianPhoneNumberPattern = /^[6-9]\d{9}$/
    return indianPhoneNumberPattern?.test(phoneNumber)
  }

  useEffect(() => {
    scrollToTop()
    fetchToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)

      const token = response?.res?.data?.access_token
      setToken(token)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }
  const handleInputChange = (event) => {
    const { name, value } = event?.target

    if (name === PHONE && !validateIndianPhoneNumber(value)) {
      setError(INVALID_MOBILE)
    } else {
      setError('')
    }

    setInputData((prevData) => ({
      ...prevData,
      name: value,
    }))
  }

  const [isFeedBackSent, setIsFeedBackSent] = useState(false)
  const fetchCustomerDetails = async () => {
    const formData = {
      clientType: CLIENT_IS?.CORPORATE,
      insuranceCategory: HEALTH,
      phoneNumber: inputData?.phone,
      email: inputData?.email,
      name: inputData?.name,
    }
    if (!validateName(inputData?.name)) {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: FORM_ERRORS?.NAME,
        })
      )
      return
    }

    if (!validateEmail(inputData?.email)) {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: FORM_ERRORS?.EMAIL,
        })
      )
      return
    }

    if (!validatePhoneNumber(inputData?.phone)) {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: FORM_ERRORS?.PHONE,
        })
      )
      return
    }

    const response = await getConfusedCustomerDetails(token, formData)

    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }

      setLoading(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        setIsFeedBackSent(true)
        setInputData({
          name: '',
          phone: '',
          email: '',
        })
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.rootContainer}>
        <div className='flex'>
          {!isFeedBackSent ? (
            <div className={classes.mainContainer}>
              <div className={classes.inputSection}>
                <div className={classes.sideContent}>
                  <span className={classes.sidecontentAction}>
                    Are You Confused?
                  </span>
                  <span className={classes.sideExpert}>
                    Let our Experts call You
                  </span>
                </div>
                <div className={classes.sideActions}>
                  <input
                    id='nameField'
                    type='text'
                    className={classes.inputControl}
                    name='name'
                    placeholder='Name'
                    value={inputData?.name}
                    onChange={handleInputChange}
                  />
                  <input
                    id='phoneField'
                    type='text'
                    className={classes.inputControl}
                    name='phone'
                    placeholder='Phone'
                    value={inputData?.phone}
                    onChange={handleInputChange}
                  />
                  {error && <span className={classes.error}>{error}</span>}
                  <input
                    id='emailField'
                    type='text'
                    className={classes.inputControl}
                    name='email'
                    placeholder='Email'
                    value={inputData?.email}
                    onChange={handleInputChange}
                  />
                  <Button
                    id='submitButton'
                    variant={'contained'}
                    className={classes.submitButton}
                    onClick={fetchCustomerDetails}
                  >
                    Submit
                  </Button>
                </div>
              </div>
              <div className={classes.imageSection}>
                <img
                  src={confused}
                  className={classes.confusedManImage}
                  alt='Confused'
                />
              </div>
            </div>
          ) : (
            <div className={classes.mainContainer}>
              <div className={classes.thankYouMessage}>
                Thank You
                <span className={classes.thankYouMessageText}>
                  for considering Trovity for your Insurance needs. Expect a
                  call from us soon to assist you.
                </span>
              </div>
              <div className={classes.imageSection}>
                <img
                  src={ContactSmile}
                  className={classes.contactSmileMan}
                  alt='ContactSmile'
                />
              </div>
            </div>
          )}
        </div>
        <div className={classes.contactImageContainer}>
          <img src={phone} alt='phone' className={classes.phoneImage} />
          <span className={classes.contactNumber}>
            <b>{CONTACT?.Contact}</b>
          </span>
        </div>
      </div>
    </>
  )
}
export default ContactUs
const useStyles = makeStyles({
  rootContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    boxShadow: '0px 2px 2px 0px #00000040',
    border: '1px',
    borderRadius: '20px',
    background: (props) =>
      props.color
        ? props.color
        : 'linear-gradient(to bottom, #EF669B -900%, #FFFFFF)',
    '@media (max-width:770px)': { flexDirection: 'column-reverse' },
  },
  mainContainer: {
    display: 'flex',
  },
  sideContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  inputSection: {
    width: '50%',
    '@media (max-width:770px)': {
      width: '100%',
    },
  },
  sidecontentAction: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#B92250',
    textAlign: 'center',
    fontStyle: 'italic',
    whiteSpace: 'nowrap',
    '@media (max-width:770px)': {
      fontSize: '8px',
    },
  },
  sideExpert: {
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'center',
    paddingLeft: '18%',
    '@media (max-width:770px)': {
      fontSize: '5px',
    },
  },
  inputControl: {
    border: '1px solid white',
    borderRadius: '20px',
    fontStyle: 'italic',
    color: '#898989',
    width: '100%',
    maxWidth: '140px',
    padding: '5px',
    boxShadow: '0px 4px 4px 0px #00000040',
    fontSize: '11px',
    fontWeight: '400',
    '@media (max-width:770px)': {
      fontSize: '5px',
      maxWidth: 'unset',
    },
  },
  submitButton: {
    background: '#B92250 !important',
    color: COLORS.WHITE,
    width: '50px ',
    fontSize: '12px !important',
    fontWeight: '400 !important',
    textTransform: 'none !important',
    height: '25px',
    padding: '12px 39px !important',
    boxShadow: '0px 4px 8px 0px #00000033 !important',
    borderRadius: '20px !important',
  },
  sideActions: {
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
    marginTop: '10px',
    '@media (max-width:770px)': {
      gap: '10px',
    },
  },
  imageSection: {
    width: '50%',
    '@media (max-width:770px)': {
      width: '100%',
    },
  },
  confusedManImage: {
    width: '100%',
    height: '100%',
  },
  contactImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '15px',
  },
  phoneImage: {
    rotate: '90deg',
    width: '25px',
    height: '25px',
  },
  contactNumber: {
    color: '#B92250',
    fontSize: '15px',
  },
  thankYouMessage: {
    fontSize: '20px',
    fontWeight: '700',
    width: '50%',
    color: '#B92250',
    textAlign: 'center',
    fontStyle: 'italic',
    margin: '10px',
    '@media (max-width:770px)': {
      width: '100%',
      fontSize: '13px',
    },
  },
  thankYouMessageText: {
    fontSize: '15px',
    textAlign: 'center',
    fontStyle: 'italic',
    margin: '10px',
    '@media (max-width:770px)': {
      width: '100%',
      fontSize: '12px',
    },
  },
  contactedImage: {
    width: '100%',
    height: '80%',
  },
  error: {
    color: 'red',
    fontSize: '12px',
    paddingLeft: '5px',
  },
})
